export const SendIcon = ({ submittable }: { submittable?: boolean }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<g clipPath="url(#clip0_9122_151208)">
				<path
					d="M23.3314 12.0118C23.3407 11.2951 22.9525 10.6364 22.322 10.2907L7.63011 2.21852C6.97206 1.8466 6.19633 1.8923 5.57625 2.31572C4.9448 2.74627 4.6216 3.77121 4.79812 4.51148L6.16967 10.2577C6.31047 10.847 6.83783 11.2619 7.44453 11.2593L15.6205 11.2339C16.0392 11.2255 16.3788 11.5651 16.3704 11.9838C16.3691 12.3953 16.0345 12.7299 15.6159 12.7383L7.43208 12.7573C6.82538 12.7584 6.29544 13.1752 6.15098 13.7653L4.73093 19.5344C4.55851 20.2162 4.75509 20.8968 5.23612 21.3778C5.29271 21.4344 5.35637 21.4981 5.42008 21.5475C6.04303 22.0281 6.85887 22.0895 7.55542 21.7183L22.2971 13.7252C22.9297 13.3897 23.322 12.7285 23.3314 12.0118Z"
					fill={submittable ? "white" : "#888DA6"}
				/>
			</g>
			<defs>
				<clipPath id="clip0_9122_151208">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
